import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className="footerWrapper">
            <div className="footerSection">
                <hr />
                <div className="row">
                    <div className="col-12 text-center">
                        <p className="copyright">{`Copyright © ${new Date().getFullYear()} FireChecked.co.uk`}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Footer;